import { Observable, zip, forkJoin } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PaymentHeader } from '@cemex-core/types-v1';
import { TranslationService } from '@cemex-core/angular-localization-v7';

import { AbstractPaymentEngine } from './abstract-payment-engine';
import { PaymentConfiguration } from './../models/payment-configuration';
import { Bank } from './../models/bank';
import { PaymentEngineConfiguration } from './payment-engine-configuration';
import { PaymentMethodDetailRequest } from './../models/payment-method-detail-request';
import { PaymentMethod } from './../models/payment-method';
import { PaymentRequest } from './../models/payment-request';
import { PayerBrokerRequest } from './../models/payer-broker-request';
import { PayerBrokerResponse } from './../models/payer-broker-response';

export class PaymentEngineGB extends AbstractPaymentEngine {

    constructor(configuration: PaymentEngineConfiguration, t: TranslationService) {
        super(configuration, t);
    }

    getBanks(): any { }

    createReference(request: PaymentRequest): Observable<any> {
        return this.paymentService.createReferenceV3(request);
    }

    getPayerBroker(request: PayerBrokerRequest, brokerCode: string): Observable<any> {
        return this.paymentService.getPayerBroker(request, brokerCode);
    }

    callToNetworking(totalToPay: string, referenceCode: string, payerInformation: PayerBrokerResponse): void {
        const formParams = this.decodeParameters(payerInformation.formParams);
        const action = formParams['IPG URL'];
        // const responseSuccessURL = window['API_HOST'] + formParams['ResponseSucessURL'];
        // const responseFailURL  = window['API_HOST'] + formParams['ResponseFailURL'];
        // const transactionNotificationURL = window['API_HOST'] + formParams['transactionNotificationURL'];
        const responseSuccessURL = formParams['ResponseSucessURL'];
        const responseFailURL  = formParams['ResponseFailURL'];
        const transactionNotificationURL = formParams['transactionNotificationURL'];
        const hostOrigin = window.location.origin;
        const redirectKOURL = hostOrigin + formParams['ResponseSucessURL_FE'];
        const redirectOKURL = hostOrigin + formParams['ResponseFailURL_FE'];
        const redirectDefault = hostOrigin + formParams['ResponseDefaultURL_FE'];

        const parameters = {
            txntype: formParams['txntype'],
            language: formParams['language'],
            timezone: formParams['timezone'],
            txndatetime: formParams['txndatetime'],
            hash_algorithm: formParams['hash_algorithm'],
            hash: formParams['hash'],
            storename: formParams['StoreName'],
            currency: formParams['currency'],
            chargetotal: totalToPay,
            mode: formParams['mode'],
            oid: referenceCode,
            paymentMethod: 'M', // CHANGE
            checkoutoption: formParams['checkoutoption'],
            responseSuccessURL: responseSuccessURL,
            responseFailURL: `${responseFailURL}?url=${encodeURIComponent(redirectDefault)}`,
            transactionNotificationURL: transactionNotificationURL,
            customParam_redirectOK: redirectOKURL,
            customParam_redirectKO: redirectKOURL,
            customParam_reference: referenceCode,
            customParam_country: 'GB' // CHANGE
        };

        this.createFormRequestNetwork(action, 'POST', '_self', parameters);
    }

    getPaymentConfiguration(): Observable<PaymentConfiguration> {
        return zip(
            super.initPaymentConfiguration(),
            this.bankService.getBankListV2({
                companyCode: this.company.companyCode,
                countryCode: this.customer.countryCode,
                customerCode: this.customer.customerCode
            })
        ).pipe(
            switchMap(([paymentConfiguration, banks]) => {
                const tt: Array<Observable<PaymentMethod>> = [];
                paymentConfiguration.paymentMethods.forEach(pm => {
                    banks.forEach(bank => {
                        tt.push(this.addPaymentMethodDetails$(paymentConfiguration, pm, bank));
                    });
                });

                const x = forkJoin(tt);

                return this.preparePaymentConfiguration$(paymentConfiguration, x);
            })
        );
    }

    private preparePaymentConfiguration$ = (paymentConfiguration: PaymentConfiguration, paymentMethods: Observable<PaymentMethod[]>) => {
        return paymentMethods.pipe(
            map((pms) => {
                paymentConfiguration.paymentMethods = pms;
                return paymentConfiguration;
            })
        );
    }

    private addPaymentMethodDetails$ = (paymentConfiguration: PaymentConfiguration, paymentMethod: PaymentMethod, bank: Bank) => {
        return this.getPaymentMethodDetails$(bank, {
            bankCode: bank.bankCode,
            countryCode: this.customer.countryCode,
            shortPaymentMethodCode: paymentMethod.shortCode
        }).pipe(
            map((responseBank) => {
                const indexPM = paymentConfiguration.paymentMethods.findIndex(x => x.shortCode === paymentMethod.shortCode);
                if (indexPM !== -1) {
                    if (paymentConfiguration.paymentMethods[indexPM].paymentNetworks) {
                        const indexB =
                            paymentConfiguration.paymentMethods[indexPM].paymentNetworks.findIndex(x => x.bankCode === bank.bankCode);
                        if (indexB !== -1) {
                            paymentConfiguration.paymentMethods[indexPM].paymentNetworks[indexB] = responseBank;
                        }
                    } else {
                        paymentConfiguration.paymentMethods[indexPM].paymentNetworks = [responseBank];
                    }
                    return paymentConfiguration.paymentMethods[indexPM];
                }
            })
        );
    }

    private getPaymentMethodDetails$ = (bank: Bank, request: PaymentMethodDetailRequest) => {
        return this.bankService.getPaymentMethodDetail(request).pipe(
            map(response => {
                response = response.filter(x => x.codeDetail !== 'A');
                bank.details = response;
                return bank;
            })
        );
    }

    saveExternalOrderRelation(): any {
        throw new Error('Method not implemented.');
    }

    getHeaderPayerInformation(request: any, payerInformationResponse: any, storeDataInfo: any): any {
        throw new Error('Method not implemented.');
    }

}
